/**
 * The free version's limits in the Home (AlertsController.NotSubscribed): before
 * creating a project (or a copy), a folder or a classroom past the limit, the
 * app's alert ("You can only create 2 projects with the free version. Please
 * subscribe…") with "Subscribe", which opens the Subscription page. The
 * functions check the same limits; their "free-limit-…" errors show it too.
 */
import { createContext, useContext } from "react";
import type { LimitKind } from "../data/subscription";

export interface FreeLimits {
  /** true when it can be created; otherwise shows the alert and returns false */
  check: (kind: LimitKind) => Promise<boolean>;
  /** shows the alert (a function said no) */
  hit: (kind: LimitKind | "images") => void;
}

export const FreeLimitsContext = createContext<FreeLimits>({ check: async () => true, hit: () => undefined });
export const useFreeLimits = () => useContext(FreeLimitsContext);

/** AlertsController.NotSubscribed's message. */
export const LIMIT_MESSAGE: Record<LimitKind | "images", string> = {
  projects: "sNotSubscribedMessageProjects",
  classrooms: "sNotSubscribedMessageClassrooms",
  folders: "sNotSubscribedMessageFolders",
  images: "imageSearchNotSubscribed",
};
